import { z } from 'zod';

const PartnerFeaturesSchema = z.object({
  single_bill: z.boolean(),
  unmanaged_campaign_copy: z.boolean(),
  partner_account_id_ui: z.boolean(),
  partner_cancel_ui: z.boolean(),
  provision_accts_to_stripe: z.boolean().optional(),
});

export const PartnerResponseSchema = z.object({
  company_name: z.string(),
  partner_id: z.number(),
  partner_name: z.string(),
  partner_parent_id: z.number(),
  features: PartnerFeaturesSchema,
  partner_contact_name: z.string(),
  partner_contact_email: z.string().email(),
});

export type PartnerResponse = z.infer<typeof PartnerResponseSchema>;
